// @flow
import * as React from 'react';

import type { SelectNativeOption } from 'reshaped';

import type { SubByTypeSort } from '@gandi/redux-places';

import { Option } from './Option';
import { OptionGroup } from './OptionGroup';
import type { OptionsProps } from './OptionGroup';

type OptionGroupItem = {
  [groupLabel: string]: Array<{ text: string, value: string }>,
};

export type Item = SelectNativeOption | OptionGroupItem;

export type Items = $ReadOnlyArray<SelectNativeOption> | SubByTypeSort;

type Props = {
  option: Item,
};

export function Options({ option }: Props): React.MixedElement {
  if (
    'label' in option &&
    'value' in option &&
    typeof option.value === 'string' &&
    typeof option.label === 'string'
  ) {
    return (
      <Option
        key={option.value}
        label={option.label}
        value={option.value}
        disabled={!!option.disabled}
      />
    );
  }

  return (
    <>
      {Object.entries(option).map(
        // $FlowFixMe[incompatible-call]
        // $FlowFixMe[prop-missing]
        ([label, options]: [string, OptionsProps]) => {
          if (!Array.isArray(options)) return null;
          return <OptionGroup key={label} label={label} options={options} />;
        },
      )}
    </>
  );
}

Options.displayName = 'Options';
